/* The Lab EQ: turn the About page FAQ (h3 + p pairs) into accordion rows.
   Authored as plain headings and paragraphs so the markup survives the admin
   rich-text editor; without this script the answers simply stay visible. */
(function () {
  function buildFaq() {
    document.querySelectorAll('.labeq-faq').forEach(function (faq) {
      if (faq.querySelector('details')) return;
      var nodes = Array.prototype.slice.call(faq.children);
      nodes.forEach(function (node) {
        if (node.tagName !== 'H3') return;
        var answer = node.nextElementSibling;
        if (!answer || answer.tagName !== 'P') return;
        var details = document.createElement('details');
        var summary = document.createElement('summary');
        summary.textContent = node.textContent.trim();
        details.appendChild(summary);
        faq.insertBefore(details, node);
        details.appendChild(answer);
        node.remove();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildFaq);
  } else {
    buildFaq();
  }
  document.addEventListener('shopify:section:load', buildFaq);
})();
